import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { MntPublicOrderRoutingModule } from './mnt-public-order-routing.module';
import { PublicOrderComponent } from './public-order/public-order.component';
import { AppMaterialModule } from '../app-material/app-material.module';
//import { ReverseArrPipe } from './reverse-arr.pipe';
//import {TimeAgoPipe} from 'time-ago-pipe';
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { MntInvoicesModule } from "../mnt-invoices/mnt-invoices.module";
import { SharedModule } from "../shared/shared.module";
import { ReverseListPipe } from './reverse-list.pipe';
import { AllMockupRevisionComponent } from './all-mockup-revision/all-mockup-revision.component';
import { MntMasterModule } from "../mnt-master/mnt-master.module";
import { StoreInvoiceComponent } from './store-invoice/store-invoice.component';



@NgModule({
  imports: [
    CommonModule,
    MntPublicOrderRoutingModule,
    AppMaterialModule,
    FormsModule,
    ReactiveFormsModule,
    MntInvoicesModule,
    SharedModule,
    MntMasterModule,
    //ReverseArrPipe
  ],
  declarations: [PublicOrderComponent, ReverseListPipe, AllMockupRevisionComponent, StoreInvoiceComponent],
  entryComponents: [AllMockupRevisionComponent]

})
export class MntPublicOrderModule { }



// WEBPACK FOOTER //
// /var/www/login.theprintlife.com/src/app/mnt-public-order/mnt-public-order.module.ts